<template>
  <div class="team__profile team__profile--2" id="team__profile--2">
    <div class="team__profile--content">
      <div class="team__profile--content--header">
        <h2 v-html="$t('teamTranslate.teamProfiles.profile2.name')" class="team__profile--content--header--name"></h2>
        <p v-html="$t('teamTranslate.teamProfiles.profile2.excerpt')" class="team__profile--content--header--excerpt"></p>
      </div>
      <div class="team__profile--content--profile team__profile--content--profile--1">
        <div class="team__profile--content--profile--photo">
          <div class="team__profile--content--profile--photo--overlay"></div>
          <img src="https://notaireleveillee.s3.ca-central-1.amazonaws.com/assets/leveille_square.JPG" alt="Profile Photo Notaire Montreal">
        </div>
      </div>
      <div class="team__profile--content--body">
        <p v-html="$t('teamTranslate.teamProfiles.profile2.body')" class="team__profile--content--body--content"></p>
        <router-link v-html="$t('teamTranslate.teamProfiles.profile2.contact')" to="/contact" tag="a" class="team__profile--content--body--link"></router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'team-variant-2',
  data () {
    return {
      locale: 'fr'
    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  }
}
</script>

<style lang="css">
</style>
